import React, { useState, useEffect } from "react";
import { Form, Select, Input, InputNumber, DatePicker } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Option } = Select;

const FunctionalityDamageForm = props => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;
    const [componentTypes, setComponentTypes] = useState([]);
    const [serviceOutageTypes, setServiceOutageTypes] = useState([]);
    const [serviceTemporaryTypes, setServiceTemporaryTypes] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data1 = await axios
                    .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/functionality-types");
                setComponentTypes(data1.data);
                
                const data2 = await axios
                    .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/functionality-outages");
                setServiceOutageTypes(data2.data);
                
                const data3 = await axios
                    .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/functionality-temporary");
                setServiceTemporaryTypes(data3.data);
                
                form.setFieldsValue({
                    functionalityType: props.record.damage.functionalityType,
                    startDate: props.record.damage.startDate ? dayjs(props.record.damage.startDate) : null,
                    endDate: props.record.damage.endDate ? dayjs(props.record.damage.endDate) : null,
                    lossOfService: props.record.damage.lossOfService,
                    functionalityOutage: props.record.damage.functionalityOutage,
                    functionalityTemporary: props.record.damage.functionalityTemporary,
                    floorNumber: props.record.damage.floorNumber,
                    apartmentCode: props.record.damage.apartmentCode,
                    temporaryDescription: props.record.damage.temporaryDescription
                });
            } catch (error) {
                console.log(error);
            };
        }
        
        fetchData();
    }, [props.record.damage, form]);

    // Handle form field changes
    const onValuesChange = (changedValues, allValues) => {
        if (!isEditMode) return;
        const newDamage = { ...props.record };
        newDamage.damage.functionalityType = elvis(allValues.functionalityType);
        newDamage.damage.startDate = elvis(allValues.startDate);
        newDamage.damage.endDate = elvis(allValues.endDate);
        newDamage.damage.lossOfService = elvis(allValues.lossOfService);
        newDamage.damage.functionalityOutage = elvis(allValues.functionalityOutage);
        newDamage.damage.functionalityTemporary = elvis(allValues.functionalityTemporary);
        newDamage.damage.floorNumber = elvis(allValues.floorNumber);
        newDamage.damage.apartmentCode = elvis(allValues.apartmentCode);
        newDamage.damage.damageClass = props.damageClass;
        newDamage.damage.temporaryDescription = elvis(allValues.temporaryDescription);
        
        // Check if form is valid
        form.validateFields()
            .then(() => {
                newDamage.valid = true;
                props.parentCallback(newDamage);
            })
            .catch(() => {
                newDamage.valid = false;
                props.parentCallback(newDamage);
            });
    };

    return (
        <Form 
            form={form}
            layout="horizontal"
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="functionalityDamageForm"
        >
            <Form.Item
                label="Category"
                name="functionalityType"
                tooltip="Component Category"
            >
                <Select disabled={!isEditMode}>
                    {componentTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('buildingEnums.functionalityType.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            
            <Form.Item label="Floor number" name="floorNumber">
                <InputNumber disabled={!isEditMode} />
            </Form.Item>

            <Form.Item label="Apartment code" name="apartmentCode"
                tooltip="Code identifying the apartment (cadastral subalterno in Italy); free text">
                <Input disabled={!isEditMode} />
            </Form.Item>

            <Form.Item label="Start Date" name="startDate">
                <DatePicker disabled={!isEditMode} />
            </Form.Item>
            
            <Form.Item label="End Date" name="endDate">
                <DatePicker disabled={!isEditMode} />
            </Form.Item>
            
            <Form.Item label="Loss of functionality (%)" name="lossOfService">
                <InputNumber disabled={!isEditMode} />
            </Form.Item>
            
            <Form.Item
                label="Usability Outcome"
                name="functionalityOutage"
                tooltip="Usability Outcome"
            >
                <Select disabled={!isEditMode}>
                    {serviceOutageTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('buildingEnums.functionalityOutage.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            
            <Form.Item
                label="Temporary measures"
                name="functionalityTemporary"
                tooltip="Temporary measures"
            >
                <Select disabled={!isEditMode}>
                    {serviceTemporaryTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('buildingEnums.functionalityTemporary.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            
            <Form.Item label="Temporary measures description" name="temporaryDescription">
                <TextArea disabled={!isEditMode} />
            </Form.Item>
        </Form>
    );
};

export default FunctionalityDamageForm;